export default {"src":"/_next/static/media/icon_chat_reject_friend.bc0c1bf4.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};